import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { REGULAR_DATE_FORMAT } from './constants';

const MonthsToDate: any = {
    1: 31,
    2: 29,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31,
};

export function getMonthName(month: any) {
    if (month === '01' || month === '1' || month === 1) {
        return 'Jan';
    }
    if (month === '02' || month === '2' || month === 2) {
        return 'Feb';
    }
    if (month === '03' || month === '3' || month === 3) {
        return 'Mar';
    }
    if (month === '04' || month === '4' || month === 4) {
        return 'Apr';
    }
    if (month === '05' || month === '5' || month === 5) {
        return 'May';
    }
    if (month === '06' || month === '6' || month === 6) {
        return 'Jun';
    }
    if (month === '07' || month === '7' || month === 7) {
        return 'Jul';
    }
    if (month === '08' || month === '8' || month === 8) {
        return 'Aug';
    }
    if (month === '09' || month === '9' || month === 9) {
        return 'Sep';
    }
    if (month === '10' || month === 10) {
        return 'Oct';
    }
    if (month === '11' || month === 11) {
        return 'Nov';
    }
    if (month === '12' || month === 12) {
        return 'Dec';
    }
    return 'Jan';
}

export function getDDMM(dateStr: string): string {
    /* eg. 01 Jan */
    if (dateStr === '') {
        return dateStr;
    }
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = getMonthName((date.getMonth() + 1).toString());
    return `${day} ${month}`;
}

/** eg. 08:08 AM || 12:39 PM */
export function getHHMM(date: string): string {
    try {
        const d = new Date(date);
        const minutes =
            d.getMinutes() > 9 ? d.getMinutes() : `0${d.getMinutes()}`;
        const ampm =
            d.getHours() > 12
                ? 'PM'
                : d.getHours() === 12 && d.getMinutes() > 0
                ? 'PM'
                : 'AM';
        const hh = d.getHours() > 12 ? d.getHours() - 12 : d.getHours();
        const h = hh > 9 ? hh : `0${hh}`;
        return `${h}:${minutes} ${ampm}`;
    } catch {
        return '';
    }
}

export function formatDateTime(
    date?: string,
    dateFormat: string = REGULAR_DATE_FORMAT
): string {
    try {
        if (!date) {
            return '';
        }
        try {
            return format(parseISO(date), dateFormat);
        } catch {
            return format(new Date(date), dateFormat);
        }
    } catch {
        return 'Invalid date';
    }
}

export function getDDMMYYYY(date: Date): string {
    if (date) {
        const day = date.getDate();
        const month = getMonthName((date.getMonth() + 1).toString());
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    }
    return '';
}

export function getDD_MM_YYYY(date: Date): string {
    if (date) {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const d = day > 9 ? day : `0${day}`;
        const m = month > 9 ? month : `0${month}`;
        return `${d}-${m}-${year}`;
    }
    return '';
}

export function getYYYY_MM_DD(date: Date): string {
    if (date) {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const d = day > 9 ? day : `0${day}`;
        const m = month > 9 ? month : `0${month}`;
        return `${year}-${m}-${d}`;
    }
    return '';
}

export function getDD_Month_Time(date: Date): string {
    if (date) {
        const day = date.getDate();
        const month = getMonthName((date.getMonth() + 1).toString());
        const time = getHHMM(date.toISOString());
        return `${day} ${month}, ${time}`;
    }
    return '';
}

export function ageCalculation(dob: string): string {
    if (dob?.length > 0) {
        const split = dob.split('-');
        if (split.length > 0) {
            const year = Number(split[0]);
            const currentYear = new Date().getFullYear();
            return (currentYear - year).toString();
        }
        return '';
    }
    return '';
}

function leapYear(year: number) {
    return year % 100 === 0 ? year % 400 === 0 : year % 4 === 0;
}

export function checkValidDate({ date, month, year }: any) {
    if (date === '0') {
        return true;
    }
    if (date === '00') {
        return false;
    }
    if (date > 31) {
        return false;
    }
    if (!month) {
        return true;
    }
    const leapYearCheck = date === 29 && month === 2 && year;
    const parsed = parseInt(month, 10);
    const monthMax = MonthsToDate[parsed];
    if (date <= monthMax) {
        if (leapYearCheck) {
            return leapYear(year);
        }
        return true;
    }
    return false;
}

export function checkValidMonth({ date, month, year }: any) {
    const parsed = parseInt(month, 10);
    if (month === '0') {
        return true;
    }
    if (month === '00') {
        return false;
    }
    if (parsed > 12) {
        return false;
    }
    if (!date) {
        return true;
    }
    const leapYearCheck = date === '29' && month === '02' && year;
    const monthMax = MonthsToDate[parsed];
    if (date <= monthMax) {
        if (leapYearCheck) {
            return leapYear(year);
        }
        return true;
    }
    return false;
}

export function checkValidYear({ date, month, year }: any) {
    if (!date || !month) {
        return true;
    }
    const leapYearCheck = date === '29' && month === '02';
    if (leapYearCheck && year.length > 3) {
        return leapYear(year);
    }
    return true;
}

export function returnDate({ date, month, year }: any) {
    return `${year}-${month}-${date}`;
}

export function getDateObject(d: string) {
    if (!d) {
        return { date: '', month: '', year: '' };
    }
    const newDate = new Date(d);
    let month = `${newDate.getMonth() + 1}`;
    let date = `${newDate.getDate()}`;

    if (month.length < 2) month = `0${month}`;
    if (date.length < 2) date = `0${date}`;
    const year = newDate.getFullYear().toString();
    return { date, month, year };
}

export const getDateDiff = (date1: any, date2: any) => {
    try {
        const diffInMs = date1 - date2;
        const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));
        return diffInDays;
    } catch {
        return 0;
    }
};

export function snakeToCapitalized(str) {
    return str
        .split('_') // Split by underscore
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(' '); // Join with space
}
